const frontpage = {
	envVarInterpolation: "Here is an environment variable for you. The value of {{varName}} is: {{value}}",
	envVarWithTags:
		"And here's a translation with tags! It shows <0>{{prop}}</0> from the <1>{{obj}}</1> object: {{value}}"
} as const;

export default frontpage;
